import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'basic-alert',
  templateUrl: './basic-alert.component.html',
  styleUrls: ['./basic-alert.component.css']
})
export class BasicAlertComponent implements AfterViewInit {
  @Input()
  title: string = "";
  @Input()
  content: string = "";
  constructor(public activeModal: NgbActiveModal) {
  }
  ngAfterViewInit(): void {
  }
}